module.exports = __webpack_public_path__ + "static/media/SpotifyOnPhoneSignal.347114d2.png";